<template>
<div class="container">
    <Breadcrumbs :here="'請求承認メッセージ一覧'"
                 :ancestries="ancestries"/>
    <div class="row">
        <div class="col h2"
             :style="{ fontSize: FontSizes.large1}">請求承認メッセージ一覧</div>
    </div>
    <div class="row justify-content-between mb-2">
        <div class="col-md-4 col-8 col-sm">
            <ClearableInput v-model:text="searchText"/>
        </div>
        <select class="month-select col-4 col-md-2 align-self-center"
                v-model="backwardMonthCountText">
            <option value="0">今月</option>
            <option value="1">前月</option>
        </select>
    </div>
    <div class="row my-3">
        <div class="col container"
             :style="{fontSize: FontSizes.small1}">
            <div class="row approval-table-header-row">
                <div class="col-1"><span class="wrap-text">社員ID</span></div>
                <div class="col-2"><span class="wrap-text">社員名</span></div>
                <div class="col-1"><span class="wrap-text">支店名</span></div>
                <div class="col-5"><span class="wrap-text">メッセージ</span></div>
                <select class="col-3 mx-n1 text-center p-0"
                        v-model="selectedAcceptState">
                    <option :value="acceptState.both">すべて表示</option>
                    <option :value="acceptState.accept">承認済み</option>
                    <option :value="acceptState.notAccept">未承認</option>
                </select>
            </div>
            <InvoiceApprovalListCell v-for="apprv in searchedApprovals"
                                     :key="apprv.vForKey"
                                     :invoice-approval="apprv"/>
            <div v-if="searchedApprovals.length === 0"
                 class="row">
                <div class="col empty-table-text align-self-center my-5"
                     :style="{fontSize: FontSizes.large1}">表示するデータは存在しません</div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import {backendApi} from "@/utils/backend-api";
import {Staff} from "@/data-models/staff";
import {logoutMessages, subPaths} from "@/utils/consts";
import {loadingOverlayStateStore} from "@/stores/loading-overlay-state-store";
import ClearableInput from "@/components/ClearableInput.vue";
import {FontSizes} from "@/utils/font-sizes";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {InvoiceApproval} from "@/data-models/invoice-approval";
import InvoiceApprovalListCell from "@/components/InvoiceApprovalListCell.vue";

export default defineComponent({
    name: "ApprovalList",
    components: {InvoiceApprovalListCell, Breadcrumbs, ClearableInput},
    setup() {

        const acceptState = {
            both: "both",
            accept : "accept",
            notAccept: "not_accept"
        }

        const route = useRoute(),
            router = useRouter()

        const  searchText = ref<string>(""),
                backwardMonthCountText = ref<string>("0"),
                searchedApprovals = ref<InvoiceApproval[]>([] as InvoiceApproval[]),
                selectedAcceptState = ref<string>(acceptState.both)

        let approvals = [] as InvoiceApproval[]

        const updateApprovals = async () => {
            console.log(backwardMonthCountText.value)
            const resp = await backendApi.inquireApprovalList(parseInt(backwardMonthCountText.value))
            if (resp.isAuthorized) {
                approvals = InvoiceApproval.fromJsonArrToArr(resp.value)
                console.log(approvals)
            } else {
                await router.push({
                    path: subPaths.LOGGED_OUT,
                    query: {
                        logout_message: logoutMessages.TOKEN_EXPIRED.key
                    }
                })
            }
        }

        const updateSearchedApprovals = () => {
            searchedApprovals.value.splice(0)
            filterApprovalsByAcceptState().forEach(apprv => {
                if (searchText.value.length === 0) {
                    searchedApprovals.value.push(apprv)
                } else {
                    if (apprv.stringForSearchWithBranch.includes(searchText.value)) {
                        searchedApprovals.value.push(apprv)
                    }
                }
            })
        }

        watch(() => backwardMonthCountText.value, async () => {
            await updateApprovals()
            updateSearchedApprovals()
        })

        watch(() => searchText.value, () => {
            updateSearchedApprovals()
        })

        watch(() => selectedAcceptState.value, () => {
            updateSearchedApprovals()
        })

        const filterApprovalsByAcceptState = (): InvoiceApproval[] => {
            const approvals2 = [] as InvoiceApproval[]
            approvals.forEach(apprv => {
                if (selectedAcceptState.value === acceptState.accept) {
                    if (apprv.accept) {
                        approvals2.push(apprv)
                    }
                } else if (selectedAcceptState.value === acceptState.notAccept) {
                    if (!apprv.accept) {
                        approvals2.push(apprv)
                    }
                } else {
                    approvals2.push(apprv)
                }
            })
            return approvals2
        }


        onMounted(async () => {

            searchText.value = ""

            await updateApprovals()
            updateSearchedApprovals()

            loadingOverlayStateStore.commit("fadeout")
        })

        return {
            backwardMonthCountText,
            searchText,
            acceptState,
            selectedAcceptState,
            FontSizes,
            searchedApprovals,
            ancestries: [
                {
                    name: "ホーム",
                    pathObj: subPaths.HOME
                }
            ],
        }
    }
})
</script>

<style scoped lang="scss">

.month-select {
    height: 30px;
}

.approval-table-header-row {
    height: 40px;
    font-weight: bold;

    border: 2px lightgray solid;

    div {
        border-left: 1px lightgray solid;
    }

    select {
        border: none;
        height: 36px;
        border-left: 1px lightgray solid;
    }
}


</style>